import { render, staticRenderFns } from "./clientMaterial.vue?vue&type=template&id=4e7723f6&scoped=true&"
import script from "./clientMaterial.vue?vue&type=script&lang=js&"
export * from "./clientMaterial.vue?vue&type=script&lang=js&"
import style0 from "./clientMaterial.vue?vue&type=style&index=0&id=4e7723f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7723f6",
  null
  
)

export default component.exports